import React from 'react';
import { motion } from 'framer-motion';



export const Toast = ({ message, type = 'success', image, title }) => {
    const icons = {
        success: 'ri-checkbox-circle-fill text-green-400',
        error: 'ri-error-warning-fill text-red-400',
        info: 'ri-information-fill text-[#C5A021]'
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            className="pointer-events-auto"
        >
            <div className="glass-panel-strong px-4 py-3 rounded-2xl border border-[#C5A021]/30 flex items-center gap-4 shadow-2xl min-w-[280px]">
                {image ? (
                    <div className="w-12 h-12 rounded-xl overflow-hidden border border-[#C5A021]/20 bg-[#140B07] flex-shrink-0 relative">
                        <img src={image} alt="" className="w-full h-full object-cover" />
                    </div>
                ) : (
                    <div className={`w-10 h-10 rounded-xl bg-[#25160F] flex items-center justify-center border border-[#C5A021]/10 flex-shrink-0`}>
                        <i className={`${icons[type]} text-xl`}></i>
                    </div>
                )}

                <div className="flex-1">
                    <p className="text-[#F8F4F0] font-outfit text-sm font-medium leading-tight">
                        {message}
                    </p>
                    <p className="text-[#C5A021] text-[10px] font-syncopate font-bold uppercase tracking-widest mt-1">
                        {title || (type === 'error' ? 'Error' : type === 'info' ? 'Notification' : 'Success')}
                    </p>
                </div>

                <div className="w-1 h-8 bg-gradient-to-b from-[#C5A021] to-transparent rounded-full opacity-30" />
            </div>
        </motion.div>
    );
};
